// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberSearchRequestModel {
    static getAttributeTypeMap() {
        return PrescriberSearchRequestModel.attributeTypeMap;
    }
}
PrescriberSearchRequestModel.discriminator = undefined;
PrescriberSearchRequestModel.additionalProperties = false;
PrescriberSearchRequestModel.attributeTypeMap = [
    {
        "name": "maxRecordCount",
        "baseName": "maxRecordCount",
        "type": "number"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "dea",
        "baseName": "dea",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "medicaidId",
        "baseName": "medicaidId",
        "type": "string"
    },
    {
        "name": "stateTaxId",
        "baseName": "stateTaxId",
        "type": "string"
    },
    {
        "name": "stateLicenseId",
        "baseName": "stateLicenseId",
        "type": "string"
    },
    {
        "name": "prescriberTaxId",
        "baseName": "prescriberTaxId",
        "type": "string"
    },
    {
        "name": "addressOne",
        "baseName": "addressOne",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "PartyExternalIdType"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
    {
        "name": "globalIdTypeCode",
        "baseName": "globalIdTypeCode",
        "type": "string"
    },
    {
        "name": "globalId",
        "baseName": "globalId",
        "type": "string"
    },
    {
        "name": "isActive",
        "baseName": "isActive",
        "type": "boolean"
    },
];
//# sourceMappingURL=prescriberSearchRequestModel.js.map